import { OrderMapper } from '../../../models/Order/OrderMapper.js';

class OrderRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  createOrder(params) {
    return this.apiClient.post('v1/orders', OrderMapper.getCreatePayload(params)).then(response => OrderMapper.createModelFromResponse(response.data));
  }
}

export { OrderRepository };
//# sourceMappingURL=OrderRepository.js.map
